import classNames from 'classnames';
import globalStyle from 'constants/global.style';
import { optionAccountComponent, optionAccountMenu } from 'constants/optionAccount';
import { PathTypeAccountInfo } from 'models/commonModel';
import React, { useEffect, useMemo, useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { IoChevronForward } from 'react-icons/io5';
import { useSearchParams } from 'react-router-dom';
import HeaderAccount from './account-option/header-account';
import styles from './account.style';

const optionMenu = optionAccountMenu.map((item) => {
    if (item.id === 'notify') {
        const newGroup = item.group.filter((component) => component.path !== 'wl-depo-his');
        return { ...item, group: newGroup, isActive: false };
    }
    return { ...item, isActive: false };
});

function AccountPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const mode: any = searchParams.get('mode');

    const [modePage, setModePage] = useState<PathTypeAccountInfo>(mode || 'personal-info');
    const [accountOption, setAccountOption] = useState<any[]>(optionMenu);

    const changePageAccount = (path: PathTypeAccountInfo) => {
        setSearchParams({ mode: path });
        setModePage(path);
    };

    useEffect(() => {
        if (mode) {
            setModePage(mode);

            const newAccountOption = accountOption.map((item) => {
                const isPathMatchGroup = item.group.map((page: any) => page.path).includes(mode);
                if (isPathMatchGroup) {
                    return { ...item, isActive: true };
                } else {
                    return { ...item, isActive: false };
                }
            });
            setAccountOption(newAccountOption);
        } else {
            const newAccountOption = accountOption.map((item, index) => {
                if (index === 0) {
                    return { ...item, isActive: true };
                } else {
                    return { ...item, isActive: false };
                }
            });
            setAccountOption(newAccountOption);
        }
    }, [mode]);

    const toggleGroupAccount = (groupId: string) => {
        const newAccountOption = accountOption.map((item: any) => {
            if (item.id === groupId) {
                return { ...item, isActive: !item.isActive };
            } else {
                return { ...item, isActive: false };
            }
        });

        setAccountOption(newAccountOption);
    };

    const dataOption = useMemo(() => {
        for (let i = 0; i < accountOption.length; i++) {
            if (accountOption[i].isActive) {
                return accountOption[i].group as { label: string; path: string }[];
            }
        }

        return [];
    }, [accountOption]);

    return (
        <div className={styles.wrap}>
            <div className={globalStyle.container} style={{ height: '100%' }}>
                <div className={styles.inner}>
                    <div className={styles.left}>
                        {accountOption.map((section, index) => (
                            <div className={classNames(styles.group, { active: section.isActive })} key={section.id}>
                                <div
                                    className={`${styles.headingGroup}  ${section.isActive ? 'active' : ''}    ${index !== 0 ? 'borderTop' : ''} `}
                                    onClick={() => (section.isActive ? null : toggleGroupAccount(section.id))}
                                >
                                    <div className={styles.groupTitle}>
                                        <section.icon size={24} color={section.isActive ? '#023639' : '#ddca8c'} />
                                        <h6 className={`${styles.title} ${section.isActive ? 'active' : ''}`}>{section.title}</h6>
                                    </div>
                                    <IoIosArrowDown size={16} color={section.isActive ? '#023639' : '#ddca8c'} className="heading-icon" />
                                </div>
                                <div className={styles.optionList} style={{ height: section.isActive ? `${section.group.length * 53}px` : 0 }}>
                                    {section.group.map((item: any, index: number) => (
                                        <div className={classNames(`${styles.optionItem}`, { active: modePage === item.path })} key={index} onClick={() => changePageAccount(item.path)}>
                                            <IoChevronForward className="iconChevron" />
                                            <p>{item.label}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className={styles.right}>
                        {optionAccountComponent.map((pageItem, index) => {
                            const Page = pageItem.component;
                            return (
                                <React.Fragment key={index}>
                                    {modePage === pageItem.path ? (
                                        <>
                                            <HeaderAccount focus={pageItem.path} dataOption={dataOption} onClickItem={changePageAccount} />
                                            <Page />
                                        </>
                                    ) : null}
                                </React.Fragment>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AccountPage;
